<template>
  <form @submit.prevent="handleSubmit" class="pago-form">
    <div class="form-group">
      <label for="pa_fecha">Fecha de Pago</label>
      <input id="pa_fecha" v-model="form.pa_fecha" type="date" required />
    </div>
    <div class="form-group">
      <label for="pa_monto">Monto en Pesos</label>
      <input id="pa_monto" v-model.number="form.pa_monto" type="number" min="1" required />
    </div>
    <div class="form-group">
      <label for="pa_periodo">Periodo (YYYYMM)</label>
      <input id="pa_periodo" v-model="form.pa_periodo" type="text" pattern="\\d{6}" maxlength="6" required :readonly="!!presetPeriodo" />
    </div>
    <div class="form-group">
      <label for="pa_monto_uf">Monto en UF</label>
      <input id="pa_monto_uf" :value="ufMonto" type="text" readonly />
      <small v-if="ufLoading">Consultando valor UF...</small>
      <small v-if="ufError" class="error">Error UF: {{ ufError }}</small>
    </div>
    <div class="form-group">
      <label for="pa_notas">Notas</label>
      <textarea id="pa_notas" v-model="form.pa_notas" rows="2" />
    </div>
    <button type="submit" :disabled="submitting || ufLoading">Guardar Pago</button>
  </form>
</template>

<script>
import apiClient from '@/api/index';
import indicadoresApi from '@/api/indicadores';

export default {
  name: 'PagoForm',
  props: {
    coId: { type: [String, Number], required: true },
    presetPeriodo: { type: String, default: '' },
    presetFecha: { type: String, default: '' },
  },
  data() {
    return {
      form: {
        pa_fecha: this.presetFecha || '',
        pa_monto: '',
        pa_periodo: this.presetPeriodo || '',
        pa_notas: '',
      },
      ufValue: null,
      ufLoading: false,
      ufError: '',
      submitting: false,
    };
  },
  computed: {
    ufMonto() {
      if (!this.ufValue || !this.form.pa_monto) return '';
      return (this.form.pa_monto / this.ufValue).toFixed(6);
    },
  },
  watch: {
    'form.pa_fecha': 'fetchUF',
    'form.pa_monto': 'fetchUF',
  },
  methods: {
    async fetchUF() {
      this.ufError = '';
      if (!this.form.pa_fecha) return;
      this.ufLoading = true;
      try {
        const res = await indicadoresApi.read({ nombre: 'uf', fecha: this.form.pa_fecha });
        this.ufValue = res.data.valor;
      } catch (e) {
        this.ufError = 'No se pudo obtener el valor UF para la fecha';
        this.ufValue = null;
      } finally {
        this.ufLoading = false;
      }
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        const payload = {
          co_id: this.coId,
          pa_fecha: this.form.pa_fecha,
          pa_monto: this.form.pa_monto,
          pa_monto_uf: this.ufMonto,
          pa_periodo: this.form.pa_periodo,
          pa_notas: this.form.pa_notas,
        };
        this.$emit('submit', payload);
        // Optionally, reset form here
      } finally {
        this.submitting = false;
      }
    },
  },
  mounted() {
    if (this.form.pa_fecha) this.fetchUF();
  },
};
</script>

<style scoped>
.pago-form {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.error {
  color: red;
}
</style>
